(() => {
  'use strict';
  if (window.OrsoGalleryCommerce) return;
  const numericId = (value) => typeof value === 'string' && /^[1-9]\d*$/.test(value) ? value : '';
  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    if (typeof root !== 'string' || !/^\/(?!\/)[^\\?#]*\/$/.test(root)) return '/';
    try {
      const url = new URL(root, window.location.origin);
      return url.origin === window.location.origin && !url.search && !url.hash && url.pathname.endsWith('/') ? url.pathname : '/';
    } catch (_) { return '/'; }
  };
  const variantCheck = (data, variant, live) => {
    const id = numericId(variant?.id);
    if (!id) return { available: false, message: 'Escolha uma combinação disponível.' };
    if (!live) return { available: false, message: 'Verifique a disponibilidade antes de adicionar ao carrinho.' };
    if (data.productId && String(live.id) !== String(data.productId)) return { available: false, message: 'Não foi possível confirmar este modelo. Confira a página do produto.' };
    const actual = live.variants.find((item) => String(item.id) === id);
    if (!actual) return { available: false, message: 'Esta combinação foi atualizada. Confira a página do produto.' };
    const expected = data.options.map((option, index) => option.values[variant.o[index]]);
    const options = Array.isArray(actual.options) ? actual.options : [actual.option1, actual.option2, actual.option3].filter((value) => value !== undefined && value !== null);
    if (options.length !== expected.length || options.some((value, index) => value !== expected[index])) return { available: false, message: 'As opções deste modelo foram atualizadas. Confira a página do produto.' };
    const price = Math.round(Number(variant.p) * 100);
    if (!Number.isFinite(price) || Number(actual.price) !== price) return { available: false, message: 'O preço deste modelo foi atualizado. Confira a página do produto.' };
    if (actual.available !== true) return { available: false, message: 'Esta combinação está indisponível no momento.' };
    return { available: true, message: '' };
  };
  function mount({ card, data, title, isActive = () => true }) {
    const handle = data.handle || card.id?.replace(/^orso-product-/, '');
    if (typeof handle !== 'string' || !handle || /[/?#]/.test(handle)) return null;
    const root = rootPath();
    const productPath = root + 'products/' + encodeURIComponent(handle);
    const form = document.createElement('form');
    form.className = 'orso-gallery-commerce';
    form.method = 'post';
    form.action = root + 'cart/add';
    form.acceptCharset = 'UTF-8';
    form.dataset.orsoGalleryCommerce = '';
    const idInput = document.createElement('input');
    idInput.type = 'hidden'; idInput.name = 'id';
    const returnInput = document.createElement('input');
    returnInput.type = 'hidden'; returnInput.name = 'return_to'; returnInput.value = root + 'cart';
    const quantityLabel = document.createElement('label');
    quantityLabel.className = 'orso-gallery-commerce__quantity';
    const quantityText = document.createElement('span');
    quantityText.textContent = 'Quantidade';
    const quantity = document.createElement('input');
    quantity.type = 'number'; quantity.name = 'quantity'; quantity.min = '1'; quantity.step = '1'; quantity.value = '1'; quantity.required = true; quantity.inputMode = 'numeric';
    quantityLabel.append(quantityText, quantity);
    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'orso-gallery-commerce__submit';
    button.textContent = 'Adicionar ao carrinho';
    button.disabled = true;
    const status = document.createElement('p');
    status.className = 'orso-gallery-commerce__status';
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
    const links = document.createElement('div');
    links.className = 'orso-gallery-commerce__links';
    const productLink = document.createElement('a');
    productLink.href = productPath; productLink.textContent = 'Ver página do produto';
    const cartLink = document.createElement('a');
    cartLink.href = root + 'cart'; cartLink.textContent = 'Ver carrinho';
    const retry = document.createElement('button');
    retry.type = 'button'; retry.className = 'orso-gallery-commerce__refresh'; retry.textContent = 'Verificar disponibilidade'; retry.hidden = true;
    links.append(productLink, cartLink, retry);
    form.append(idInput, returnInput, quantityLabel, button, status, links);
    const position = card.querySelector('[data-orso-selection]');
    if (!position) return null;
    position.after(form);
    let selected = null;
    let revision = 0;
    let live = null;
    let inFlight = null;
    let checking = false;
    let disposed = false;
    let phase = 'idle';
    let readMessage = '';
    let feedback = '';
    const quantityValue = () => {
      const value = Number(quantity.value);
      return Number.isSafeInteger(value) && value >= 1 ? value : null;
    };
    const render = () => {
      if (disposed) return;
      const id = numericId(selected?.id);
      idInput.value = id;
      productLink.href = productPath + (id ? '?variant=' + encodeURIComponent(id) : '');
      const check = variantCheck(data, selected, live);
      const validQuantity = quantityValue() !== null;
      button.disabled = phase !== 'idle' || checking || !validQuantity || !check.available;
      quantity.readOnly = phase === 'navigating' || phase === 'uncertain';
      form.setAttribute('aria-busy', String(checking || phase === 'submitting' || phase === 'navigating'));
      button.textContent = phase === 'submitting' ? 'Confirmando disponibilidade…' : phase === 'navigating' ? 'Abrindo carrinho…' : 'Adicionar ao carrinho';
      status.textContent = feedback || (checking ? 'Verificando disponibilidade…' : !validQuantity ? 'Informe uma quantidade inteira a partir de 1.' : readMessage || check.message);
      retry.hidden = !readMessage || phase !== 'idle' || checking;
      retry.disabled = phase !== 'idle' || checking;
    };
    const load = () => {
      if (disposed) return Promise.reject(new Error('disposed'));
      if (inFlight) return inFlight;
      checking = true;
      readMessage = '';
      render();
      inFlight = Promise.resolve().then(async () => {
        const controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
        let timer;
        const deadline = new Promise((_, reject) => {
          timer = window.setTimeout(() => { controller?.abort(); reject(new Error('timeout')); }, 8000);
        });
        let body;
        const request = Promise.resolve().then(async () => {
          const response = await window.fetch(productPath + '.js', { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json, application/javascript;q=0.9, text/javascript;q=0.9' }, ...(controller ? { signal: controller.signal } : {}) });
          if (response.status === 404) throw new Error('unavailable');
          if (!response.ok) throw new Error('unconfirmed');
          const contentType = (response.headers?.get('content-type') || '').split(';')[0].trim().toLowerCase();
          // The Ajax .js endpoint may label its JSON as JavaScript. Parse data only; never execute it.
          if (!['application/json', 'application/javascript', 'text/javascript'].includes(contentType)) throw new Error('unconfirmed');
          if (response.url) {
            const finalURL = new URL(response.url, window.location.origin);
            if (finalURL.origin !== window.location.origin || finalURL.pathname !== productPath + '.js') throw new Error('unconfirmed');
          }
          const value = await response.json();
          if (!value || !Array.isArray(value.variants) || !value.variants.length) throw new Error('unconfirmed');
          return value;
        });
        try {
          body = await Promise.race([request, deadline]);
        } finally { window.clearTimeout(timer); }
        if (!disposed) live = body;
        return body;
      }).catch((error) => {
        if (!disposed) {
          live = null;
          readMessage = error.message === 'unavailable' ? 'Este modelo ainda não está disponível para compra.' : 'Não foi possível confirmar a disponibilidade. Tente verificar novamente.';
        }
        throw error;
      }).finally(() => {
        inFlight = null;
        checking = false;
        render();
      });
      return inFlight;
    };
    const submit = async (event) => {
      event.preventDefault();
      if (disposed || phase !== 'idle' || !isActive()) return;
      const variant = selected;
      const id = numericId(variant?.id);
      const count = quantityValue();
      if (!id || count === null) { render(); return; }
      const submittedRevision = revision;
      phase = 'submitting';
      feedback = '';
      render();
      try {
        const confirmed = await load();
        if (disposed) return;
        if (!isActive() || !form.isConnected) {
          phase = 'idle'; feedback = ''; render(); return;
        }
        if (revision !== submittedRevision || numericId(selected?.id) !== id || quantityValue() !== count) {
          phase = 'idle'; feedback = 'Sua seleção mudou. Confira as opções antes de adicionar ao carrinho.'; render(); return;
        }
        const check = variantCheck(data, variant, confirmed);
        if (!check.available) {
          phase = 'idle'; feedback = check.message; render(); return;
        }
        idInput.value = id;
        quantity.value = String(count);
        phase = 'navigating';
        feedback = 'Abrindo o carrinho…';
        render();
        try {
          window.HTMLFormElement.prototype.submit.call(form);
        } catch (_) {
          phase = 'uncertain';
          feedback = 'Não foi possível confirmar o envio. Confira o carrinho antes de tentar novamente.';
          render();
        }
      } catch (_) {
        if (disposed) return;
        phase = 'idle'; feedback = ''; render();
      }
    };
    const onQuantity = () => { revision += 1; if (phase === 'idle') feedback = ''; render(); };
    const onRetry = () => { if (phase === 'idle') { feedback = ''; load().catch(() => {}); } };
    form.addEventListener('submit', submit);
    quantity.addEventListener('input', onQuantity);
    retry.addEventListener('click', onRetry);
    const onPageShow = (event) => {
      if (!event.persisted || disposed || phase === 'uncertain') return;
      revision += 1;
      phase = 'idle'; feedback = ''; live = null; render();
      if (isActive()) load().catch(() => {});
    };
    window.addEventListener('pageshow', onPageShow);
    render();
    return {
      update(variant) {
        if (disposed) return;
        if (selected !== variant) revision += 1;
        selected = variant || null;
        if (phase === 'idle') feedback = '';
        render();
      },
      open() { if (!disposed && phase === 'idle') { feedback = ''; load().catch(() => {}); } },
      close() { if (!disposed) { revision += 1; if (phase === 'idle') feedback = ''; } },
      destroy() {
        disposed = true;
        form.removeEventListener('submit', submit);
        quantity.removeEventListener('input', onQuantity);
        retry.removeEventListener('click', onRetry);
        window.removeEventListener('pageshow', onPageShow);
        form.remove();
      },
    };
  }
  window.OrsoGalleryCommerce = Object.freeze({ mount });
})();
